<template>
    <section class="about">
        <div class="about_carousel">
            <div class="carousel_img">
                <div class="carousel_con">
                    <div></div>
                    <div class="about_title">
                        <h2>关于糖德</h2>
                        <h2>About us</h2>
                    </div>
                    <div class="about_dingwei">
                        <a v-for="(item) in aboutData" :key="item.id" @click="anchor(item.id)">{{ item.name }}
                        </a>
                        <!-- :href=" '#' + item.id" -->
                    </div>
                </div>
            </div>
        </div>
        <div class="introduce" id="content1">
            <div ref="product1" class="introduce_con">
                <h1>企业介绍</h1>
                <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="13">
                        <div class="introduce_zuo">
                            <div>
                                <h2>以简驭繁、还原生活本真 </h2>
                                <span></span>
                            </div>
                            <p>厦门鸿宁兴科技有限公司属于一体化数字采购管理服务商，通过提供SaaS采购数字化产品，
                                致力于数字化采购变革，为企业提供企业采购数字化解决方案，推动企业采购更加智能、
                                高效、透赋能企业经营发展降本提效。</p>
                            <div>
                                <div><span></span>
                                    <h2>使命</h2>
                                </div>
                                <div>坚持一丝不苟的品质控制、力求每个细节的完美呈现。</div>
                            </div>
                            <div>
                                <div><span></span>
                                    <h2>愿景</h2>
                                </div>
                                <div>成为一家全球化科技公司、为产品后的每个企业负责。</div>
                            </div>
                            <div>
                                <div><span></span>
                                    <h2>核心价值观</h2>
                                </div>
                                <div>长期价值、用户体验、数据、纯粹、极致、突破边界。</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="10">
                        <div class="introduce_you">
                            <img src="../assets/tutop.png" />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="business" id="content2">
            <div ref="product2" class="business_con">
                <h1>业务与服务</h1>
                <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="24">
                        <div class="business_list">
                            <div class="business_item" v-for="item of businessData" :key="item.id">
                                <div>
                                    <img :src="item.img" />
                                    <span>{{ item.title }}</span>
                                    <small>{{ item.text }}</small>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="product" id="content3">
            <div ref="product3" class="product_con">
                <h1>我们的合作伙伴</h1>
                <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="7">
                        <div class="product_zuo">
                            <div>
                                <div>
                                    <div>合作伙伴</div>
                                    <div>COOPERATIVE PARTNER</div>
                                    <div></div>
                                </div>
                                <div>
                                    <div>与每一种力量</div>
                                    <div>共筑智慧、便捷、美好生活</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="16">
                        <div class="cooperation_you">
                            <div class="cooperation_box">
                                <span></span>
                                <span></span>
                            </div>
                            <el-carousel indicator-position="outside" :autoplay="false" arrow="never"
                                style="height: 29.3125rem;overflow:hidden">
                                <el-carousel-item v-for="ite of 3" :key="ite.id" style="height: 29.3125rem">
                                    <div class="cooperation_con">
                                        <div v-for="item of cooperationData" :key="item.id">
                                            <img :src="item.img" />
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            <div class="cooperation_box">
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </section>
</template>
  
<script>
import SlideBar from "../components/sidebar.vue";
export default {
    components: { SlideBar },
    data() {
        return {
            aboutData: [
                { name: '企业介绍', id: 'content1' },
                { name: '业务与服务', id: 'content2' },
                { name: '合作伙伴', id: 'content3' },
                { name: '联系我们', id: 'content4' }

            ],
            cooperationData: [
                { img: require('../assets/co1.png') },
                { img: require('../assets/co2.png') },
                { img: require('../assets/co3.png') },
                { img: require('../assets/co4.png') },
                { img: require('../assets/co5.png') },
                { img: require('../assets/co6.png') },
                { img: require('../assets/co7.png') },
                { img: require('../assets/co8.png') },
                { img: require('../assets/co9.png') },
                { img: require('../assets/co10.png') },
                { img: require('../assets/co11.png') },
                { img: require('../assets/co12.png') },
            ],
            businessData: [
                { img: require('../assets/tu1.png'), title: 'SaaS开放平台', text: '丰富的API和SDK,支持定制企业专属的应用' },
                { img: require('../assets/tu2.png'), title: '主营业务', text: '与餐饮企业战略合作，打造oem数据一体化 支付平台。' },
                { img: require('../assets/tu3.png'), title: '定制化服务', text: '支持大型销售团队定制 开发服务' },
                { img: require('../assets/tu4.png'), title: '24小时响应', text: '24小时快速响应客户需求 第一时间解决' },
                { img: require('../assets/tu5.png'), title: '现场培训', text: '提供现场系统使用培训服务 帮助员工快速上手' },
                { img: require('../assets/tu6.png'), title: 'SLA承诺', text: '为服务的有效性、可靠性、专业性 提供保障' },
            ]
        }
    },
    methods: {
        anchor(id) {
            const $ele = document.getElementById(id)
            if ($ele) {
                let total = $ele.offsetTop
                document.documentElement.scrollTop = total - 50
                // $ele.scrollIntoView()
            }
        }
    },
    created() {
    },
    mounted() {
        window.addEventListener('scroll', () => {
            console.log(document.body.scrollWidth, '111');
            let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
            if (top > 50) {
                this.$refs.product1?.classList.add('animate__fadeInUp')
                // this.$refs.product1?.classList.add('animate__animated')
            }
            if (top > 650) {
                this.$refs.product2?.classList.add('animate__fadeInUp')
                // this.$refs.product2?.classList.add('animate__animated')
            }
            if (top > 1400) {
                this.$refs.product3?.classList.add('animate__fadeInUp')
                // this.$refs.product3?.classList.add('animate__animated')
            }

        })
    },
}
</script>
  
<style lang="scss" scoped>
.about {
    position: relative;
}


.head {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.carousel_con {
    animation: fadenum 2s;
}

@keyframes fadenum {

    0% {
        transform: translateX(-250px);
    }

}

.carousel_img {
    background: url("../assets/tubg.png") no-repeat center center;
    background-size: cover;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // padding: 0 7.5rem 2.5rem 7.5rem;
    height: 40.3125rem;

    .carousel_con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: column;
        width: 100%;
        height: 100%;

        .about_title {

            &>h2 {
                font-size: 3.125rem;
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
            }

            &>h2:nth-child(2) {
                opacity: 0.4;
            }
        }

        .about_dingwei {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            width: 100%;
            margin-bottom: 1.625rem;

            &>a {
                font-size: 1.625rem;
                font-weight: 400;
                color: #FFFFFF;
                text-decoration: none;
                cursor: pointer;
            }
        }
    }
}

.introduce {
    min-height: 48.875rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    padding: 2.5rem 7.5rem;
    background: url("../assets/tuxu1.png") no-repeat center center;
    background-size: cover;
    width: 100%;

    .introduce_con {

        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;

        &>h1 {
            font-size: 2.5rem;
            font-weight: bold;
            color: #333333;
            text-align: center;
            margin-bottom: 2.875rem;
        }

        .introduce_zuo {
            &>p {
                font-size: 1.125rem;
                font-weight: 400;
                color: #333333;
                margin: 3.75rem 0;
            }

            &>div:first-child {
                &>h2 {
                    font-size: 2.125rem;
                    font-weight: bold;
                    color: #333333;
                }

                &>span {
                    display: block;
                    width: 1.25rem;
                    height: .25rem;
                    background: #0E6EB8;
                    margin-top: 1.625rem;
                }
            }

            &>div {
                line-height: 2.5rem;
                margin-bottom: 3.125rem;

                &>div:first-child {
                    display: flex;
                    align-items: center;

                    &>h2 {
                        font-size: 2.125rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    &>span {
                        display: block;
                        width: 1.25rem;
                        height: .25rem;
                        background: #0E6EB8;
                        margin-right: 1.625rem;
                    }
                }

                &>div:nth-child(2) {
                    font-size: 1.125rem;
                    font-weight: 500;
                    color: #666666;
                    margin-left: 2.875rem;
                }
            }
        }

        .introduce_you {
            width: 33.5rem;
            height: 40.125rem;

            &>img {
                height: 100%;
                width: 100%;
            }
        }
    }
}

.business {
    min-height: 46.875rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F9F9F9;
    padding: 2.5rem 7.5rem;

    .business_con {
        width: 100%;

        &>h1 {
            font-size: 2.5rem;
            font-weight: bold;
            color: #333333;
            text-align: center;
        }

        .business_list {
            display: grid;
            grid-template-rows: repeat(2, 1fr);
            grid-template-columns: repeat(3, 1fr);
            grid-gap: 1.25rem;
            margin-top: 3.75rem;

            .business_item:hover {
                // transform: scale(1.1);
                box-shadow: 0px 0px 2rem 0px rgba(1, 20, 35, 0.08);
            }

            .business_item {
                // width: 483px;
                height: 18.9375rem;
                background: #FFFFFF;
                border: .1875rem solid #EEEEEE;
                border-radius: .625rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &>div {
                    width: 60%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-flow: column;
                    line-height: 1.875rem;
                    text-align: center;

                    &>img {
                        width: 5.5625rem;
                        height: 4.125rem;
                    }

                    &>span {
                        font-size: 1.75rem;
                        font-weight: bold;
                        color: #333333;
                        margin: 1.375rem 0;
                    }

                    &>small {
                        font-size: 1rem;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
        }
    }
}

.product {
    min-height: 46.875rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    padding: 1rem 7.5rem 2.5rem 7.5rem;
    // padding: 1rem 0 2.5rem 0;


    .product_con {
        width: 100%;

        &>h1 {
            font-size: 2.5rem;
            font-weight: bold;
            color: #333333;
            text-align: center;
        }

        &>div {
            display: flex;
            // justify-content: center;
            margin-top: 3.75rem;

            .product_zuo {
                display: flex;
                flex-flow: column;
                justify-content: space-between;
                // width: 20%;
                height: 100%;

                &>div:first-child {
                    &>div:first-child {

                        line-height: 1.875rem;

                        &>div:first-child {
                            font-size: 1.5rem;
                            font-weight: 400;
                            color: #333333;
                        }

                        &>div:nth-child(2) {
                            font-size: 1rem;
                            font-weight: 400;
                            color: #333333;
                        }

                        &>div:nth-child(3) {
                            width: 1.25rem;
                            height: .25rem;
                            background: #0E6EB8;
                            margin-top: .625rem;
                        }
                    }

                    &>div:nth-child(2) {
                        font-size: 1.7rem;
                        font-weight: bold;
                        color: #333333;
                        margin-top: 1.625rem;
                    }
                }

                &>div:nth-child(2) {
                    line-height: 1.625rem;

                    &>div:first-child {
                        font-size: .875rem;
                        font-weight: 400;
                        color: #4D4D4D;
                        display: flex;
                        align-items: center;

                        &>img {
                            margin-left: .625rem;
                        }
                    }

                    &>div:nth-child(2) {
                        width: 20rem;
                        height: .125rem;
                        background: #333333;
                        margin-top: 1rem;
                    }
                }
            }

            .cooperation_you {
                // width: 60%;

                .cooperation_box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    &>span {
                        width: 1rem;
                        height: 1rem;
                        background: #D4D4D4;
                    }
                }

                .cooperation_con {
                    display: grid;
                    grid-template-rows: repeat(3, 1fr);
                    grid-template-columns: repeat(4, 1fr);
                    padding-left: 3.75rem;
                    padding-top: 2.625rem;

                    &>div:hover {
                        transform: scale(1.1);
                    }

                    &>div {
                        width: 8rem;
                        height: 8rem;
                        overflow: hidden;
                        position: relative;

                        // border: 1px solid red;
                        &>img {
                            width: 100%;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }
    }
}
</style>
<style>
@media screen and (max-width: 600px) {}
</style>
  